// src/components/User/UserForm.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getUserById, createUser, updateUser, getRoles } from '../../services/api';
import { Form, Input, Select, Button, message } from 'antd';

const UserForm = () => {
  const [form] = Form.useForm();
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    fetchRoles();
    if (id) fetchUser();
  }, [id]);

  const fetchRoles = async () => {
    try {
      const response = await getRoles();
      setRoles(response.data);
    } catch (error) {
      message.error('Failed to fetch roles');
    }
  };

  const fetchUser = async () => {
    setLoading(true);
    try {
      const response = await getUserById(id);
      form.setFieldsValue(response.data);
    } catch (error) {
      message.error('Failed to fetch user');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      if (id) {
        await updateUser(id, values);
        message.success('User updated successfully');
      } else {
        await createUser(values);
        message.success('User created successfully');
      }
      navigate('/users');
    } catch (error) {
      message.error(id ? 'Failed to update user' : 'Failed to create user');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form form={form} onFinish={handleSubmit} layout="vertical">
      <Form.Item name="userId" hidden>
        <Input />
      </Form.Item>
      <Form.Item
        name="username"
        label="Username"
        rules={[{ required: true, message: 'Please input username!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="password"
        label="Password"
        rules={[{ required: !id, message: 'Please input password!' }]}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item
        name="email"
        label="Email"
        rules={[{ required: true, message: 'Please input email!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="fullName"
        label="Full Name"
        rules={[{ required: true, message: 'Please input full name!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="roleId"
        label="Role"
        rules={[{ required: true, message: 'Please select role!' }]}
      >
        <Select placeholder="Select role">
          {roles.map((role) => (
            <Select.Option key={role.roleId} value={role.roleId}>
              {role.roleName}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          {id ? 'Update' : 'Create'}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default UserForm;
